import React, { forwardRef, useState } from "react";
import classNames from "classnames";

import OpenEyeIcon from "@/icons/eye-open.svg";
import CloseEyeIcon from "@/icons/eye-close.svg";
import Typography from "@/components/Typography";
import { InputInterface } from "@/components/Input/Input.interface";

import styles from "./Input.module.scss";

export const Input: React.FC<InputInterface> = forwardRef(
  (
    {
      name,
      type = "text",
      placeholder,
      required,
      error,
      className,
      icon: Icon,
      defaultValue,
      disabled,
      onChange,
      handleChange,
    },
    ref
  ) => {
    const [isActive, setActive] = useState<boolean>(false);
    const [isVisible, setVisible] = useState<boolean>(false);
    const isPasswordType = type === "password";
    const inputType = !isPasswordType ? type : isVisible ? "text" : "password";

    const toggleVisible = (e) => {
      e.preventDefault();
      setVisible((prevState) => !prevState);
    };

    return (
      <div className={className}>
        <div
          className={classNames(
            styles.inputWrapper,
            error && styles.error,
            disabled && styles.disabled,
            isActive && styles.active
          )}
        >
          {Icon && <Icon className={styles.icon} />}
          <input
            name={name}
            type={inputType}
            placeholder={placeholder}
            required={required}
            onChange={onChange || (handleChange as any)}
            className={styles.input}
            ref={ref}
            defaultValue={defaultValue}
            disabled={disabled}
            onFocus={() => {
              setActive(true);
            }}
            onBlur={() => setActive(false)}
          />
          {isPasswordType && (
            <button
              type="button"
              onClick={toggleVisible}
              className={classNames(
                styles.password,
                isVisible && styles.visible
              )}
              tabIndex={-1}
            >
              {!isVisible ? <OpenEyeIcon /> : <CloseEyeIcon />}
            </button>
          )}
        </div>
        {error && (
          <Typography variant="small" component="p" className={styles.message}>
            {error}
          </Typography>
        )}
      </div>
    );
  }
);

export default Input;
